import styled from "styled-components";

export const LoginPage = styled.div`
    // background: url('/assets/partner-deal-red.jpg');
    background-repeat:no-repeat;
    backgraound-size:cover;
    padding: 0;
	margin: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
	overflow: hidden;
`;

export const Wave = styled.img`
    position: fixed;
	bottom: 0;
	left: 0;
	height: 100%;
    z-index: -1;
    
    @media screen and (max-width: 900px) {
        & {
            display: none;
        }
    }
`;

export const Container = styled.div`
    width: 100vw;
	height: 100vh;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 7rem;
   // padding: 0 2rem;
    
    @media screen and (max-width: 1050px) {
        & {
            grid-gap: 0rem;
        }
    }

    @media screen and (max-width: 900px) {
        & {
            grid-template-columns: 1fr;
        }

        .empty {
            display: none;
        }
    }
`;

export const HistoryWidget = styled.div`
    .item{
        align-items: center;
        display: flex;
        &.border-right{
            border-right: 1pX solid #ebebeb;
        }
        svg{
            color: #BF2F38;
            width: 48px;
            height: 48px;
            display: block;
            margin-right: 16px;
            path{
                stroke: #BF2F38;
            }
        }
        h3{
            font-weight: 200;
            text-transform: initial;
            margin: 0;
            font-size: 16px;
        }
        .number{
            font-weight: 500;
            font-size: 30px;
            line-height:30px;
            &.small{
                line-height:25px;
                font-size:25px;
            }
        }
        @media screen and (max-width: 700px) {
            flex:none;
            padding-bottom:15px;
            padding-top:15px;
            
            &.border-right{
                border-right: none !important;
                border-bottom: 1px solid #ebebeb;
            }
        }
    }
`;

export const ImgContent = styled.div`
    display: flex;
	justify-content: flex-end;
    align-items: center;
    
    img {
	    width: 500px;
    }

    @media screen and (max-width: 1000px) {
        img {
            width: 400px;
        }
    }

    @media screen and (max-width: 900px) {
        & {
            display: none;
        }
    }
`;

export const LoginContent = styled.div`
    display: flex;
	/* justify-content: flex-start; */
	justify-content: center;
	align-items: center;
    text-align: center;

    flex-direction: column;
    img {
        height: 100px;
    }

    h2 {
        margin: 15px 0;
        color: #333;
        text-transform: uppercase;
        font-size: 2.9rem;
        margin-top: 0 !important;
    }

    sub {
        color: #555 !important;
        font-size: 1em !important;
    }
    .title{
        font-size:22px;
    }

    .alert {
        max-width: 400px;
    }
    @media screen and (max-width: 1000px) {
        h2 {
            font-size: 2.4rem;
		    margin: 8px 0;
        }

        .alert {
            max-width: 330px;
        }
    }

    @media screen and (max-width: 900px) {
        & {
            justify-content: center;
        }
    }
`;

export const LoginForm = styled.form`
    width: 360px;

    span {
        color: #BF2F38 !important;
    }

    a {
        cursor: pointer;
    }

    @media screen and (max-width: 1000px) {
        & {
            width: 290px;
        }
    }
`;

export const InputDiv = styled.div`
    position: relative;
	display: grid;
	grid-template-columns: 7% 93%;
	margin: 5px 0;
	padding: 5px;
    border-bottom: 1px dotted #BF2F38;
    
    &:after, &:before {
        content: '';
        position: absolute;
        bottom: -2px;
        width: 0%;
        height: 2px;
        background-color: #BF2F38;
        transition: .4s;
    }

    &:before {
        right: 50%;
    }

`;

export const InputDivOne = styled(InputDiv)`
    margin-top: 0;
`;

export const InputIcon = styled.div`
    color: #d9d9d9;
	display: flex;
	justify-content: center;
    align-items: center;
    
    i {
        transition: .3s;
    }
`;

export const InputRest = styled.div`
    color: #d9d9d9;
	display: flex;
	justify-content: center;
    align-items: center;
    position: relative;
	height: 45px;
`;

export const Input = styled.input`
    position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	background: none;
	padding: 0.5rem 0.7rem;
	font-size: 18px;
    color: #555;
    &.sm{
        font-size:16px;
    }
`;

export const InputDivPass = styled(InputDiv)`
    margin-bottom: 4px;
`;

export const Button = styled.button`
    display: block;
	width: 100%;
	height: 50px;
	border-radius: 25px !important;
	outline: none;
	border: none;
	background-image: linear-gradient(to right, #F5212F, #BF2F38, #F5212F);
	background-size: 200%;
	font-size: 1.2rem;
	color: #fff !important;
	text-transform: uppercase;
	margin: 1rem 0;
	cursor: pointer;
    transition: .5s;
    
    &:hover {
        background-position: right;
    }

    &:disabled {
        background: #9F3636;
    }
`;

export const Link = styled.a`
    display: block;
	text-align: center;
	text-decoration: none;
	color: #999;
	font-size: 0.9rem;
    transition: .3s;
    
    &:hover {
        color: #BF2F38;
    }
`;

/* Home Page */

export const HomePage = styled.div`
    position: fixed;
	padding: 0;
	margin: 0;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
    background-color: #F3F6F8;
`;

export const HomeHeader = styled.header`
    background-color: #fff;
	box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.28);
	height: 8%;
	color: #BF2F38;
	display: flex;
	align-items: center;
	justify-content: space-between;
    padding: 0 7px;
    
    span:hover {
        color: #555;
        cursor: pointer;
    }
`;

export const ButtonExit = styled.button`
    background-color: transparent;
    color: #BF2F38;
	cursor: pointer;
	border: none;
    /* vertical-align: middle; */
    
    &:hover {
        color: #555;
    }
`;

export const HeaderLogo = styled.img`
    width: 100px;
`;

export const HomeInfo = styled.section`
    margin: 25px 50px 0 50px;
    box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.28);
	border: 1px solid #D4D7D9;
    border-radius: 14px;
    padding: 5px;

    @media screen and (max-width: 900px) {
        margin: 5px 20px 0 20px;

        h1 {
            font-size: 2rem;
        }
    }
`;

export const HomeContent = styled.section`
    height: 92%;
    height: 100%;
    overflow: auto;
    padding-top: 16px;
    @media(max-width: 700px) {
        padding-top: 16px;
    }
`;

export const HomeBody = styled.section`
    display: flex;
	//border: 1px solid #D4D7D9;
	border-radius: 14px;
	margin: 15px 50px 0 50px;
	min-height: 400px;
    //box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.28);
    
    @media screen and (max-width: 900px) {
        flex-direction: column;
		/* height: 75%; */
		margin: 15px 10px 20px 10px;
    }
`;

export const Search = styled.section`
    border-top-left-radius: 14px;
	border-bottom-left-radius: 14px;
	width: 55%;
    //background-color: #FFFFFF;
    min-height: 320px;
    margin:auto;
    
    h3 {
        margin-top: 25px;
    }
    
    @media screen and (max-width: 900px) {
        border-top-left-radius: 14px;
		border-top-right-radius: 14px;
		border-bottom-left-radius: 0;
		width: 100%;
        flex: 1;
        padding:0 20px;
    }
`;

export const SearchForm = styled.form`
    width: 360px;

    @media screen and (max-width: 1000px) {
        & {
            width: 100%;
        }
    }
`;

export const ButtonSearch = styled(Button)`
    
	width: 100%;
	margin: 0 auto;
	//margin-top: 25px;
    font-size: 14px;
    
    padding:8px 20px;
    vertical-align: "middle";
    svg{
        width:24px;
        margin-right:10px;
        height:24px;
    }
`;

export const ButtonClear = styled(Button)`
    height: 30px;
	width: 30px;
	margin-top: 0;
	margin-right: 30px;
	/* margin-top: 10px; */
	/* margin-right: 50px; */
    font-size: 16px;
    position: absolute;
    right: 0;
    z-index: 1 !important;

    @media screen and (max-width: 900px) {
		margin-right: 20px;
    }
`;

export const Result = styled.section`
    /* background-color: #F9F9F9; */
	border-top-right-radius: 14px;
	border-bottom-right-radius: 14px;
	border-bottom-left-radius: 14px;
	width: 60%;
    margin:auto;    
    padding-bottom: 80px;
    @media screen and (max-width: 900px) {
        width: 100%;
		flex: 1;
    }
`;

export const ResultInfo = styled.section`
    margin: 40px;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    -webkit-box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
    padding: 20px;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: relative;



    .logo {
        width: 40%;
        margin-bottom: 22%;
    }

    .qrcode {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 20%;
        height: 40%;

        i {
            display: block;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: right;
            width: 100%;
            height: 100%;
        }
    }

    .icon {
        position: absolute;
        left: 50%;
        top: 50%;
        background-color: #BF2F38;
        color: white;
        width: 38px;
        height: 38px;
        border-radius: 28px;
        margin-left: -14px;
        margin-top: -14px;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
    } 

    .name {
        text-transform: uppercase;
        letter-spacing: 2px;
        font-weight: bold;
    }

    .club-number {
        font-size: 22px;
        letter-spacing: 1px;
        margin-bottom: 8px;
    }

    .data {
        font-size: 11px;
        text-transform: uppercase;
    }

    .member {
        opacity: .7;
        padding: 4px 6px 3px 6px;
        border-radius: 4px;
        text-transform: uppercase;
        position: absolute;
        letter-spacing: 1px;
        right: 20px;
        bottom: 20px;
        font-weight: bold;
        font-size: 11px;

        @media(max-width: 700px) {
            span {
                display: none;
            }
        }
    }

    .member2 {
        font-variant: small-caps;

        span {
            background-color: #EAECEF;
        }
    }

    .notMember {
        font-style: italic;
    }

    .info {
        font-weight: bold;
    }

    @media screen and (max-width: 700px) {
        margin: 10px 0;
        height: 90%;

        .icon {
            opacity: 0.8;
            width: 30px;
            height: 30px;
            line-height: 30px;
        }

        .data {
            font-size: 10px;
        }

        .name {
            font-size: .8rem;
        }

        .member {
            font-size: 8px;
        }
    }
`;

export const NotResultInfo = styled.section`
    margin: 40px;
	height: 80%;
	border-radius: 14px;
	box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.28);

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	color: #b8c2cc;
`;

export const ButtonResult = styled(ButtonSearch)`
    width: 50%;
`;

export const Logo = styled.img`
    width: 45px;
    height: 45px;
    border: 1px solid rgba(32, 33, 36, 0.28);

	box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.28);
    border-radius: 30px;
    margin-right: 5px;
`;

export const DiscountInfo = styled.div`
   
    display:inline-block;
    div{
        display:inline-block;
        margin-right:6px;
        font-size:14px;
    }

    .exclusivo {
        background-color: #D4AF34;
        color:#fff;
    }

    .base {
        background-color: #bf2f38;
    }

    .money {
        font-size: 1rem;
        font-weight: bold;
    }

    .ao {
        font-size: 0.6rem;
    }

    @media screen and (max-width: 700px) {
        padding: 0 2px 0 2px;
        
        p {
            font-size: smaller;
        }
    }

    @media(max-width: 360px) {
        p {
            font-size: .6rem;
        }

        h3 {
            font-weight: bold;
        }
    }
`;

export const OfferInfo = styled.div`
    padding: 0 6px;

    .others {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    h3 {
        font-size: 1.2rem;
        margin-bottom: 0;
    }

    @media (max-width:700px) {
        padding: 0 0 0 3px;

        .days, .dates {
            font-size: 0.77rem;
        }
    }
`;

/* PAge Not Found */

export const NotFoundPage = styled(LoginPage)`
    @media screen and (max-width: 970px) {
        background-color: azure;
    }
`;

export const NotFoundContent = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;

    img {
        height: 250px;
    }

    h3 {
        color: #BF2F38;
    }

    @media screen and (max-width: 1196px) {
        img {
            height: 150px;
        }

    }
`;


export const Profile = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 20px;
    width:40%;
    margin:auto;

    img {
        height: 80px;
        width: 80px;
    }

    .logo {
        border-radius: 80px;
        background-color: #fff;
        box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.15);
    }

    @media screen and (max-width: 900px) {
        width:100%;
    }
`;

export const ResetPasswordPage = styled(LoginPage)`
    .card {
        padding: 30px;
        box-shadow: 0 2px 6px 0 rgba(32, 33, 36, 0.15);

        .card-body {
            text-align: left !important;

            .react-custom-flag-select__select__selector___1JJ_x {
                padding-left: 0 !important;
            }

            .react-custom-flag-select__select__options-item___3_6R4.react-custom-flag-select__active___2SYE9,
            .react-custom-flag-select__select__hover-active___1ECCY {
                background-color: #BF2F38 !important;
            }

            h1, p {
                color: #333f48;
            }
        }
    }
`;